import { READINESS_FEATURES, type FeatureDef } from '@/lib/readiness/module'

// ── Product navigation model (Sidebar spec §1.3, §6 rule 8) ─────────────────
// The sidebar's items, order, labels and routes come from the module's own
// features (`READINESS_FEATURES`, Dashboard first, Settings `coming_soon`),
// flat, exactly as the drawer listed them. Each item is a single-page module
// (no expandable groups yet).

export interface NavItem {
  key: string
  label: string
  route: string
  icon: string
  // Which pathnames show this destination as the active one.
  match: (pathname: string) => boolean
  // Readiness items carry the selected index in their query (`?index=`).
  withIndex?: boolean
  // `coming_soon` renders disabled with a chip and never navigates (I6 §15).
  status?: FeatureDef['status']
  // POC feature gate (I6 POC §2): a locked item keeps navigating to its preview.
  gate?: FeatureDef['gate']
}

export const READINESS_ITEMS: NavItem[] = READINESS_FEATURES.map((f) => ({ key: f.key, label: f.label, route: f.route, icon: f.icon, match: f.match, withIndex: true, status: f.status, gate: f.gate }))

export const isReadinessPath = (pathname: string) => pathname === '/readiness' || pathname.startsWith('/readiness/')

export function navItemsForPath(_pathname: string): NavItem[] {
  return READINESS_ITEMS
}
